import { useMemo } from 'react';

import { SG_FEATURES } from '../utils/features';
import { useSgCow, useSgCowEvents } from '../contexts/cow';
import SgTrend from './trend';
import { FeatureCard } from './cow-detail';

import '../styles/sg.css';

// Datos productivos de Software Ganadero de una vaca cowre, para la vista de estadísticas.
// El endpoint /admin/sg/cows/:id usa el animal_id de cowre (mismo puente que el navegador
// SG → useSgCow/useSgCowEvents aceptan el id de cowre directo). Cada dato usa el gráfico
// adecuado: series continuas (leche L, peso kg) → gráfica de tendencia; eventos discretos
// (servicios, partos, palpaciones, tratamientos) → tarjeta "último evento". Si la vaca no
// está conciliada con SG (404) la sección no se muestra. El backend calcula; el front grafica.

const CHART_FEATURES = SG_FEATURES.filter((f) => f.chart); // leche, peso → serie continua

// Cuenta los puntos numéricos de una serie (SgTrend necesita ≥2 para dibujar).
const seriesCount = (rows, field) => rows.reduce((n, ev) => {
    const raw = ev?.payload?.[field];
    return (raw !== null && raw !== undefined && raw !== '' && Number.isFinite(Number(raw))) ? n + 1 : n;
}, 0);

function FeatureTrend({ animalId, def }) {
    const { data, isLoading } = useSgCowEvents({ cowId: animalId, feature: def.key, limit: 100 });
    const rows = useMemo(() => (data?.pages || []).flatMap((p) => p?.items || []), [data]);
    const count = seriesCount(rows, def.chart.field);

    return (
        <div className="sg-prod__chart">
            {count >= 2 ? (
                <SgTrend rows={rows} chart={def.chart} />
            ) : (
                <div className="sg-prod__chart-empty">
                    <span className="sg-prod__chart-label">{def.chart.label}</span>
                    <span className="sg-prod__chart-hint">{isLoading ? 'Cargando…' : 'Sin serie suficiente (≥2 registros).'}</span>
                </div>
            )}
        </div>
    );
}

export default function SgProductivePanel({ animalId }) {
    const { data, isLoading, error } = useSgCow(animalId);

    // Sin enlace SG (404) o cargando → no se muestra la sección (no ensucia las stats).
    if (isLoading || error || !data) return null;

    return (
        <article className="report-card sg-prod">
            <div className="sg-prod__head">
                <h2 className="report-section__title">Datos productivos · Software Ganadero</h2>
                {data.sg_count != null && <span className="sg-prod__count">{data.sg_count} ficha{data.sg_count === 1 ? '' : 's'} SG</span>}
            </div>

            <div className="sg-prod__charts">
                {CHART_FEATURES.map((f) => <FeatureTrend key={f.key} animalId={animalId} def={f} />)}
            </div>

            <div className="sg-feats sg-prod__cards">
                {SG_FEATURES.map((f) => <FeatureCard key={f.key} def={f} entry={data.last_events?.[f.key] || null} />)}
            </div>
        </article>
    );
}
